import React from "react";
import { BCMSRecord, useRoute, useBCMSContext, useWorkflowStep , useParams, Link } from "@bcm-dev/bcms-vite";
import { Card } from "model";
import { getWorkflowSteps, getDefault } from "components/workflows/BalanceTransferWorkflow";
import { UIPrimaryButton } from "components/ui/UIButton";
import { DisabledPrompt } from "@bcm-dev/bcms-vite";
import { SVGAsset } from "res";

import "./styles.css";
import { TransferReviewDetails } from "../TransferReviewDetails";

/**
 * @function TransferConfirmationView
 * @return {React.Component}
 * @exported true
 * @description The main component for TransferConfirmationView
 */
export default function TransferConfirmationView(props) {
  const globalController = useBCMSContext();
  BCMSRecord.globalControllerFor([ Card ], globalController);
  const navigate = useRoute();
  const workflowStep = useWorkflowStep(getDefault, getWorkflowSteps);
  const state = workflowStep.getStepState;
  const hiddenEmail = state.email ?? "test@mail.com";
  const cardID = useParams().cardID ?? "0";

  const route = evt => navigate(`/home/recenttransactions/${ cardID }`);
 
  return (
    <div className="transfer-confirmation-view">
      <div className="framed-icon-container">
        <SVGAsset id="CheckmarkIcon" />
      </div>
      <div className="content-container text-center">
        <b>We've received your balance transfer request</b>
      </div>
      <div className="content-container text-left">
        <p>It may take up to 7 business days to process and mail the check to the other financial institution.</p>
      </div>
      <div className="content-container text-left">
        <p>Please continue to make one-time payments until your balance transfer is reflected on the monthly billing statement.</p>
      </div>
      <div className="content-container text-left">
        <p>An email notification confirming this request has been sent to the primary email address on file, {hiddenEmail}.</p>
      </div>
      <TransferReviewDetails form={ state } />
      <div className="flex-container flex-horizontal align-center-container content-container contact-us-container">
        <DisabledPrompt>
          <Link className="contact-us-link clickable">Contact us</Link>
        </DisabledPrompt>&nbsp;
        <span className="sub-text">for details.</span>
      </div>
      <div className="content-container text-center">
        <UIPrimaryButton text="Done" onClick={ route }/>
      </div>
    </div>
  )
}
